//React
import * as React from "react";

//Redux
import { connect } from "react-redux";

//Components
import QrReader from "react-qr-reader";
import QuaggaScanner from "./QuaggaScanner";
import Button from "material-ui/Button";
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle } from "material-ui/Dialog";
import {
    ListItem,
    ListItemAvatar,
    ListItemSecondaryAction,
    ListItemText
} from "material-ui/List";
import Avatar from "material-ui/Avatar";
import Card from "material-ui/Card";
import Divider from "material-ui/Divider";
import IconButton from "material-ui/IconButton";
import AnnoucementIcon from "material-ui-icons/Announcement";
import CloseIcon from "material-ui-icons/Close";
import PhotoCamera from "material-ui-icons/PhotoCamera";
import Home from "material-ui-icons/Home";
import Typography from "material-ui/Typography";
import TextField from "material-ui/TextField";

//Managers
import { StyleManager } from "./../../managers/StyleManager";

//Framework
import { ScanMode_e } from "../../framework/ScanMode";
import { UserProfile_e } from "../../framework/user/UserProfile";
//import { Category_e } from "../../framework/Category";

//Icones
import { Power, Build, Tab, LightbulbOutline } from "material-ui-icons";
import { MethodRequest_e, NetworkManager } from "../../managers/NetworkManager";
import { SSL_OP_TLS_BLOCK_PADDING_BUG } from "constants";
import { MainStore } from "../../store/MainStore";
import { FormControl, InputLabel, Input } from "material-ui";

//Style
const styles = StyleManager.getStyles().QrCodeReaderComponent;

function once(target, type, listener, useCapture) {
    const capture = !!useCapture;
    target.addEventListener(type, handler, capture);

    function deregister() {
        target.removeEventListener(type, handler, capture);
    }

    function handler(this) {
        deregister();
        return listener.apply(this, arguments);
    }

    return deregister;
}

interface CodeReaderProps {
    categoriesChecked?: any;
    switched: boolean;
    userProfile: UserProfile_e;
    warehouses?: any;
}

interface CodeReaderState {
    askLocation : boolean;
    camera: boolean;
    cart: any;
    error: any;
    damagedText: string;
    detect: boolean;
    idDamagedTool: number;
    idDeleteProduct: number;
    open: boolean;
    openDamagedDialog: boolean;
    openDeleteProductDialog: boolean;
    openErrorDialog: boolean;
    openFinishReturnProductDialog: boolean;
    openLocationDialog: boolean;
    openReturnProductDialog: boolean;
    openUnborrowedProductDialog: boolean;
    remark: string;
    result: any;
    scanMode: ScanMode_e;
    selectedStock: any;
    showButtons: boolean;
    stocks: any;
    worksite: string;
}

/**
 * @description Contain the QrCodeCReader Component
 * @author Lucas Fridez <lfridez@artionet.com>
 * @export
 * @class QrCodeReader
 * @extends {React.Component}
 */
export default connect<{}, {}, CodeReaderProps>((state) => state)(class QrCodeReader extends React.Component<CodeReaderProps, CodeReaderState> {

    /**
     * Creates an instance of QrCodeReader.
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof QrCodeReader
     */
    constructor(props) {
        super(props);
        this.state = {
            askLocation: false,
            camera: false,
            cart: [],
            damagedText: "",
            detect: false,
            error: "",
            idDamagedTool: 0,
            idDeleteProduct: 0,
            open: false,
            openDamagedDialog: false,
            openDeleteProductDialog: false,
            openErrorDialog: false,
            openFinishReturnProductDialog: false,
            openLocationDialog: false,
            openReturnProductDialog: false,
            openUnborrowedProductDialog: false,
            remark: "",
            result: "",
            scanMode: ScanMode_e.NONE,
            selectedStock: {},
            showButtons: false,
            stocks: [],
            worksite: ""
        };
        this.handleScan = this.handleScan.bind(this);

        /*if (this.state.scanMode === ScanMode_e.RETURN_TOOLS) {
            this.setCameraOn();
        }*/
    }

    /**
     * @description Switch the camera
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} props
     * @memberof QrCodeReader
     */
    componentWillReceiveProps(props) {
        /*if(props.switched != this.props.switched) {
            this.setState({
                camera: false,
                openErrorDialog: false,
                scanMode: this.props.userProfile == UserProfile_e.FITTER ? ScanMode_e.NONE : ScanMode_e.RETURN_TOOLS,
                selectedStock: {},
                showButtons: false
            });
        }*/
        this.setState({
            detect: props.switched ? true : false
        });
    }

    /**
     * @description Enclenche the camera
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    setCameraOn() {
        this.setState({ camera: true, detect: true });
        once(window, "blur", () => { this.setCameraOff(); }, "");
    }

    /**
     * @description Declenche the camera
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    setCameraOff() {
        this.setState({ camera: false, detect: false });
    }

    /**
     * @description Detection of a QRCode successed
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} data
     * @memberof QrCodeReader
     */
    handleScan(data) {
        if (data) {
            this.setState({ detect: false, result: data }); //Set detect mode to false
            //Work with the correct mode (fitter or agency manager)

            let alreadyInCart: boolean = false;

            this.state.cart.forEach((material) => {
                if(data.uid == material.uid){
                    alreadyInCart = true;
                }
            });

            if (this.props.userProfile == UserProfile_e.FITTER || this.state.scanMode == ScanMode_e.LOCATION_FROM_STOCK) {
                if(this.state.scanMode == ScanMode_e.LOCATION_FROM_STOCK && data.borrowed) {
                    this.openErrorDialog("Scanner depuis l'entrepôt", "Seulement, le matériel est actuellement loué et ne se trouve donc pas dans un entrepôt.", "Emprunter à un collègue");
                } else if (this.state.scanMode == ScanMode_e.LOCATION_BETWEEN_EMPLOYEES && !data.borrowed) {
                    this.openErrorDialog("Emprunter à un collègue", "Seulement, le matériel n'est actuellement pas loué. Il se trouve donc dans un entrepôt.", "Scanner depuis l'entrepôt");
                } else if(alreadyInCart) {
                    // Don't do anything
                } else {
                    this.openDialogBorrow();
                }
            } else {
                if (data.borrowed) {
                    this.setState({
                        openReturnProductDialog: true
                    });
                } else {
                    this.setState({
                        openUnborrowedProductDialog: true
                    });
                }
            }
            this.setState({ detect: true }); //Set detect mode to true
        }
    }

    /**
     * @description Show error is the QR Code isn't correctly read
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param {any} err
     * @memberof QrCodeReader
     */
    handleError(err) {
        console.error(err);
    }

    /**
     * @description Open the Dialog when QR Code is read
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    openDialogBorrow = () => {
        this.setState({ open: true });
    }

    /**
     * @description Show the damagedDialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    handleClickOpenDamagedDialog = (idDamagedTool) => {
        this.setState({ openDamagedDialog: true, idDamagedTool: idDamagedTool });
    }

    /**
     * @description Hide the damagedDialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    handleCloseDamagedDialog = () => {
        this.setState({ openDamagedDialog: false });
    }

    /**
     * @description Close the Damaged Tool Dialog & show the Tool in damaged mode
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    handleCloseDamagedTool = (idDamagedTool) => {
        let _cart = this.state.cart;

        _cart[this.state.idDamagedTool].damaged = true;
        _cart[this.state.idDamagedTool].damages = this.state.damagedText;

        this.setState({
            cart: _cart
        });
    }

    /**
     * @description Show the LocationDialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    handleClickOpenLocationDialog = () => {
        this.setState({ openLocationDialog: true });
    }

    /**
     * @description Hide the LocationDialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    handleCloseLocationDialog = async (accepted) => {
        if (accepted) {
            if (this.props.userProfile == UserProfile_e.FITTER || this.state.scanMode == ScanMode_e.LOCATION_FROM_STOCK) { //Borrow Products
                MainStore.showOverlay("Création des emprunts");
                this.setState({ askLocation: false, openLocationDialog: false });
                try {
                    await NetworkManager.request("borrows", MethodRequest_e.POST, {
                        borrows: this.state.cart,
                        from: this.state.selectedStock.name,
                        responsibleAgency: this.props.userProfile == UserProfile_e.AGENCY_MANAGER,
                        user: NetworkManager.getUserId()
                    }).then(() => {
                        MainStore.getProductListing(`?categories=${encodeURIComponent(JSON.stringify(this.props.categoriesChecked.categories))}`);
                    });
                    MainStore.hideOverlay();
                } catch (error) {
                    NetworkManager.showError("Erreur lors de la création des emprunts. Veuillez rééssayer.");
                }
            }
        }

        this.setState({
            cart: [],
            openLocationDialog: false,
            scanMode: ScanMode_e.NONE,
            showButtons: false
        });
    }

    /**
     * @description Close Dialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    closeDialogBorrow = () => {
        this.setState({ open: false });
    }

    /**
     * @description Open Dialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    openDialogReturnBorrow = () => {
        this.setState({
            openReturnProductDialog: true
        });
    }

    openErrorDialog = (title: string, explication: string, text: string) => {
        this.setState({
            error: {
                explication: explication,
                text: text,
                title: title
            },
            openErrorDialog: true
        });
    }

    closeErrorDialog = () => {
        this.setState({
            askLocation: false,
            camera: false,
            openErrorDialog: false,
            scanMode: ScanMode_e.NONE,
            showButtons: false
        });
    }

    /**
     * @description Open Dialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    openFinishDialogReturnBorrow = () => {
        this.setState({ openFinishReturnProductDialog: true });
    }

    /**
     * @description Close Dialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    closeDialogReturnBorrow = () => {
        this.setState({ openReturnProductDialog: false });
    }

    closeDialogFinishReturnBorrows = async (accepted) => {
        this.setCameraOff();
        this.setState({ askLocation: false, openFinishReturnProductDialog: false, scanMode: ScanMode_e.NONE, showButtons: false });
        if (accepted) {
            MainStore.showOverlay("Mise à jour des matériels en cours...");
            try {
                await NetworkManager.request("borrows/close", MethodRequest_e.PUT, {
                    "borrows": this.state.cart,
                    "warehouse": this.state.selectedStock.id
                });
                MainStore.getProductListing(`?categories=${encodeURIComponent(JSON.stringify(this.props.categoriesChecked.categories))}`);
                MainStore.hideOverlay();
            } catch (error) {
                NetworkManager.showError("Erreur lors du retour du matériel. Veuillez rééssayer.");
            }
        }
        this.setState({ cart: [] });
    }

    /**
     * @description Close Dialog
     * @author Lucas Fridez <lfridez@artionet.com>
     * @memberof QrCodeReader
     */
    closeUnborrowedProductDialog = () => {
        this.setState({
            openUnborrowedProductDialog: false
        });
    }

    /**
     * @description Add the scanned product to the cart
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param product the product that will be added to the cart
     * @memberof QrCodeReader
     */
    addProductToCart = (product, remark, worksite) => {
        this.setState({
            cart: [...this.state.cart, { id: product.pid, name: product.name, damaged: false, damages: [], uid: product.uid, bid: product.bid, remark: remark, worksite: worksite }],
            remark: "",
            worksite: ""
        });
    }

    /**
     * @description Add the scanned product to the cart (to return it in warehouses)
     * @author Lucas Fridez <lfridez@artionet.com>
     * @param product the product that will be added to the cart
     * @memberof QrCodeReader
     */
    addBorrowsToCloseToCart = (product) => {
        this.setState({
            cart: [...this.state.cart, { bid: product.bid, name: product.name, pid: product.pid }]
        });
    }

    handleClickDeleteProductFromCart = () => {
        let _cart = this.state.cart;
        _cart.splice(this.state.idDeleteProduct, 1);

        this.setState({
            cart: _cart,
            openDeleteProductDialog: false
        });
    }

    /**
     * @description Render the QR Code Component
     * @author Lucas Fridez <lfridez@artionet.com>
     * @returns QrCodeReader Component
     * @memberof QrCodeReader
     */
    render() {
        return (
            <div>
                {/* ASK THE SCAN MODE */}
                {this.state.scanMode === 0 &&
                    <div>
                        <Typography type="headline" gutterBottom>Que voulez-vous faire ?</Typography>
                        <Card>
                            <ListItem button onClick={() => {
                                this.setState({ askLocation: true, scanMode: ScanMode_e.LOCATION_FROM_STOCK });
                            }}>
                                <ListItemAvatar>
                                    <Avatar> <PhotoCamera /> </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={"Scanner depuis l'entrepôt"} />
                            </ListItem>
                            <Divider />
                            <ListItem button onClick={() => {
                                this.setState({ scanMode: ScanMode_e.LOCATION_BETWEEN_EMPLOYEES, showButtons: true });
                                this.setCameraOn();
                            }}>
                                <ListItemAvatar>
                                    <Avatar> <PhotoCamera /> </Avatar>
                                </ListItemAvatar>
                                <ListItemText primary={"Emprunter à un collègue"} />
                            </ListItem>
                            {this.props.userProfile == UserProfile_e.AGENCY_MANAGER && 
                            <div>
                                <Divider />
                                <ListItem button onClick={() => {
                                    this.setState({ askLocation: true, scanMode: ScanMode_e.RETURN_TOOLS });
                                }}>
                                    <ListItemAvatar>
                                        <Avatar> <PhotoCamera /> </Avatar>
                                    </ListItemAvatar>
                                    <ListItemText primary={"Rendre du matériel à l'entrepôt"} />
                                </ListItem>
                            </div>
                            }
                        </Card>
                    </div>}

                {/* SHOW STOCK LIST */}
                {this.state.askLocation && !this.state.showButtons &&
                    <div>
                        <Typography type="headline" gutterBottom>Où vous trouvez-vous ?</Typography>
                        <Card>
                            {this.props.warehouses.warehouses.map((stock, key) => (
                                <div key={key}>
                                    <ListItem button onClick={() => { this.setState({ showButtons: true, selectedStock: stock }); this.setCameraOn(); }}>
                                        <ListItemAvatar>
                                            <Avatar><Home /></Avatar>
                                        </ListItemAvatar>
                                        <ListItemText primary={stock.name} />
                                    </ListItem>
                                    <Divider />
                                </div>))
                            }
                        </Card>
                    </div>
                }

                {/* QR Code Reader*/}
                {this.state.camera &&
                    <QuaggaScanner
                        cameraOn={this.state.camera}
                        onDetected={(product) => { this.handleScan(product); }}
                        detectMode={this.state.detect}
                    />
                }

                {!this.state.camera && this.state.showButtons &&
                    <div style={{
                        alignItems: "center",
                        backgroundColor: "#424242",
                        display: "flex",
                        justifyContent: "center",
                        paddingTop: "100%",
                        position: "relative",
                        width: "100%"
                    }}>
                        <div style={{
                            alignItems: "center",
                            bottom: 0,
                            color: "#FAFAFA",
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            justifyContent: "center",
                            left: 0,
                            position: "absolute",
                            right: 0,
                            top: 0,
                            width: "100%"
                        }}>
                            <PhotoCamera />
                            <p>La caméra est éteinte.</p>
                        </div>
                    </div>
                }

                {this.state.showButtons &&
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", margin: 8 }}>
                        {!this.state.camera && <Button raised color="primary" onClick={() => { this.setCameraOn(); }}>Allumer</Button>}
                        {this.state.camera && <Button raised color="primary" onClick={() => { this.setCameraOff(); }}>Eteindre</Button>}
                    </div>
                }

                {this.state.scanMode !== 0 && this.state.showButtons && this.state.cart.length > 0 &&
                    <div>
                        <Typography type="headline">Mon panier</Typography>
                        <Card>
                            {this.state.cart.map((product, key) => (
                                <div key={key}>
                                    <ListItem>
                                        <ListItemAvatar>
                                            <Avatar style={product.damaged ? styles.damagedIcon : styles.undamagedIcon}>
                                                <Power />
                                            </Avatar>
                                        </ListItemAvatar>
                                        <ListItemText
                                            primary={product.name} />
                                        <ListItemSecondaryAction>
                                            <IconButton aria-label="Annoucement" style={{width: "36px"}} onClick={() => { this.handleClickOpenDamagedDialog(this.state.cart.length - 1); }}>
                                                <AnnoucementIcon />
                                            </IconButton>
                                            <IconButton aria-label="Supprimer" style={{width: "36px"}} onClick={() => { this.setState({openDeleteProductDialog: true, idDeleteProduct: key}); }}>
                                                <CloseIcon />
                                            </IconButton>
                                        </ListItemSecondaryAction>
                                    </ListItem>
                                    <Divider />
                                </div>))
                            }
                        </Card>
                        {this.state.cart.length > 0 &&
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "center", margin: 8 }}>
                                <Button raised color="primary" onClick={() => {
                                    this.setCameraOff();
                                    if (this.props.userProfile == UserProfile_e.FITTER || this.state.scanMode == ScanMode_e.LOCATION_FROM_STOCK) {
                                        this.handleClickOpenLocationDialog();
                                    } else {
                                        this.openFinishDialogReturnBorrow();
                                    }
                                }}>
                                    {this.props.userProfile == UserProfile_e.AGENCY_MANAGER && this.state.scanMode == ScanMode_e.RETURN_TOOLS ? "Rendre le matériel" : "Emprunter le matériel"}
                                </Button>
                            </div>
                        }
                    </div>}

                {/* DIALOG SHOWN WHEN QR CODE IS READ */}
                <Dialog
                    open={this.state.open}
                    onClose={this.closeDialogBorrow}
                    aria-labelledby="Location d'outils">
                    <DialogTitle>{"Location de matériel"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            <span>Êtes-vous sûr de vouloir emprunter le matériel suivant : {this.state.result.name} ?</span>
                        </DialogContentText>
                        <div style={{color: "rgba(0,0,0,0.54)", marginTop: 5}}>
                        {this.state.result.damages && this.state.result.damages.length > 0 ? <div>
                                <span>Attention, il dispose des dégâts suivants :</span>
                                <ul style={{margin: 0}}>
                                    {this.state.result.damages.map((damage, key) => (
                                        <li key={key}>{damage.text}</li>
                                    ))}
                                </ul>
                            </div>
                                : ""}
                        </div>
                        <div style={{color: "rgba(0,0,0,0.54)", marginTop: 5}}>
                        {this.props.userProfile == UserProfile_e.AGENCY_MANAGER &&
                        <FormControl style={{width: "100%", marginBottom: 16}}>
                            <InputLabel>Remarque</InputLabel>
                            <Input
                                multiline
                                value={this.state.remark}
                                onChange={(event) => this.setState({
                                    remark: event.target.value
                                })} />
                        </FormControl>}
                        </div>
                        <div style={{color: "rgba(0,0,0,0.54)", marginTop: 5}}>
                        {this.state.result.category == "Tableaux" &&
                        <FormControl style={{width: "100%", marginBottom: 16}}>
                            <InputLabel>Chantier *</InputLabel>
                            <Input
                                value={this.state.worksite}
                                onChange={(event) => this.setState({
                                    worksite: event.target.value
                                })} />
                        </FormControl>}
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button raised onClick={this.closeDialogBorrow} style={styles.disagreeButton}>
                            Annuler
                        </Button>
                        <Button
                            disabled={this.state.result.category == "Tableaux" && this.state.worksite.length == 0}
                            raised
                            onClick={() => { this.addProductToCart(this.state.result, this.state.remark, this.state.worksite); this.closeDialogBorrow();}}
                            style={((this.state.result.category == "Tableaux" && this.state.worksite.length != 0) || this.state.result.category != "Tableaux") ? styles.agreeButton : {}}
                            autoFocus>
                            Accepter
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog shown when borrow will be returned */}
                <Dialog
                    open={this.state.openReturnProductDialog}
                    onClose={this.closeDialogReturnBorrow}
                    aria-labelledby="Location d'outils">
                    <DialogTitle>{"Retour de matériel"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Êtes-vous sûr de vouloir retourner le matériel suivant : {this.state.result.name}
                            ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button raised onClick={this.closeDialogReturnBorrow} style={styles.disagreeButton}>
                            Annuler
                        </Button>
                        <Button
                            raised
                            onClick={() => { this.addBorrowsToCloseToCart(this.state.result); this.closeDialogReturnBorrow(); }}
                            style={styles.agreeButton}
                            autoFocus>
                            Accepter
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Dialog shown when product isn't borrowed yet */}
                <Dialog
                    open={this.state.openUnborrowedProductDialog}
                    onClose={this.closeUnborrowedProductDialog}
                    aria-labelledby="Location d'outils">
                    <DialogTitle>{"Location de matériel"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Le matériel suivant : {this.state.result.name} n'est pas loué. Il n'est pas possible de le retourner à l'entrepôt.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            raised
                            onClick={this.closeUnborrowedProductDialog}
                            style={styles.agreeButton}
                            autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* DAMAGED TOOL DIALOG */}
                <Dialog
                    open={this.state.openDamagedDialog}
                    disableBackdropClick={true}
                    aria-labelledby="Matériel endommagé">

                    <DialogTitle id="form-dialog-title">Matériel endommagé</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Vous désirez annoncer le matériel <strong>{this.state.result.name}</strong> comme étant endommagé. Veuillez décrire les dégâts ci-dessous.
                        </DialogContentText>
                        <TextField
                            autoFocus multiline margin="dense" id="damage" label="Description du dommage" type="text" fullWidth
                            onChange={(event) => {
                                this.setState({
                                    damagedText: event.target.value
                                });
                            }}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button style={{
                            backgroundColor: "#E53935",
                            color: "#FFF"
                        }} onClick={this.handleCloseDamagedDialog} raised>Annuler</Button>
                        <Button style={styles.validationButton} onClick={() => { this.handleCloseDamagedTool(this.state.idDamagedTool); this.handleCloseDamagedDialog(); }} raised>Annoncer</Button>
                    </DialogActions>
                </Dialog>

                {/* DIALOG CONFIRMATION LOCATION*/}
                <Dialog
                    open={this.state.openLocationDialog}
                    disableBackdropClick={true}
                    aria-labelledby="Location de matériel">

                    <DialogTitle id="form-dialog-title">Location de matériel</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Voulez-vous louer tout le matériel précédemment scanné ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button style={{
                            backgroundColor: "#E53935",
                            color: "#FFF"
                        }} onClick={() => { this.handleCloseLocationDialog(false); }} raised>Non</Button>
                        <Button style={styles.validationButton} onClick={() => { this.handleCloseLocationDialog(true); }} raised>Oui</Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    open={this.state.openErrorDialog}
                    disableBackdropClick={true}
                    aria-labelledby="Erreur de saisie">

                    <DialogTitle id="form-dialog-title">Erreur de saisie</DialogTitle>
                    <DialogContent>
                        <DialogContentText style={{fontSize: "14px", textAlign: "justify"}}>
                            Vous avez sélectionné le mode &laquo; <strong>{this.state.error.title}</strong> &raquo; {this.state.error.explication}
                        </DialogContentText>
                        <DialogContentText style={{fontSize: "14px", textAlign: "justify"}}>
                            Veuillez sélectionner le mode &laquo; <strong>{this.state.error.text}</strong> &raquo; pour emprunter ce matériel.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button style={styles.validationButton} onClick={() => { this.closeErrorDialog();}} raised>Choix du mode</Button>
                    </DialogActions>
                </Dialog>

                {/* DIALOG CONFIRMATION RETURN BORROWS*/}
                <Dialog
                    open={this.state.openFinishReturnProductDialog}
                    disableBackdropClick={true}
                    aria-labelledby="Retour de matériels">

                    <DialogTitle id="form-dialog-title">Retour de matériels</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Voulez-vous retourner tout le matériel précédemment scanné ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button style={{
                            backgroundColor: "#E53935",
                            color: "#FFF"
                        }} onClick={() => { this.handleCloseLocationDialog(false); }} raised>Non</Button>
                        <Button style={styles.validationButton} onClick={() => { this.closeDialogFinishReturnBorrows(true); }} raised>Oui</Button>
                    </DialogActions>
                </Dialog>

                {/* DIALOG DELETE BORROW */}
                <Dialog
                    open={this.state.openDeleteProductDialog}
                    disableBackdropClick={true}
                    aria-labelledby="Suppression du panier">

                    <DialogTitle id="form-dialog-title">Suppression du panier</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Voulez-vous vraiment supprimer le matériel {this.state.cart.length > 0 && this.state.cart[this.state.idDeleteProduct] ? this.state.cart[this.state.idDeleteProduct].name : null} du panier ?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button style={{
                            backgroundColor: "#E53935",
                            color: "#FFF"
                        }} onClick={() => { this.setState({ openDeleteProductDialog: false}) }} raised>Non</Button>
                        <Button style={styles.validationButton} onClick={() => { this.handleClickDeleteProductFromCart(); }} raised>Oui</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./src/app/UI/components/QrCodeReader.tsx